import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrHelper } from '../../../helpers/toastr.helper';
import { AuthenticatedUser } from '../../../models/identity/authenticated-user.model';
import { AccountsService } from '../../../services/identity/accounts.service';
import { ProjectsService } from '../../../services/projects/projects.service';
import { MatchingProject } from '../../models/matching-project.model';

@Component({
    selector: 'app-widget-project',
    templateUrl: './widget-project.component.html',
    styleUrls: ['widget-project.component.scss'],
})
export class WidgetProjectComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    public projects: MatchingProject[] = [];

    public joinProjectDialog = false;

    public isLoading = true;

    public currentUser: AuthenticatedUser;
    public userSkills: string[];
    public userInterests: string[];
    public userTags: string[];

    constructor(
        private readonly projectsService: ProjectsService,
        private readonly toastrHelper: ToastrHelper,
        private router: Router,
        private readonly accountsService: AccountsService,
    ) {}

    public ngOnInit() {
        this.currentUser = this.accountsService.currentUser;
        this.userInterests = this.currentUser.interests.map((interest) => interest.name);
        this.userSkills = this.currentUser.skills.map((skill) => skill.displayName);
        this.userTags = [...this.userInterests, ...this.userSkills];
        this.loadProjects();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public loadProjects() {
        this.projectsService
            .getMatchedProjects()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (projects) => {
                    this.projects = projects;
                    this.isLoading = false;
                },
                (error) => {
                    this.toastrHelper.showGenericError(error);
                },
            );
    }

    public userJoinedProject(): void {
        this.loadProjects();
    }

    public goToProjectPage(projectId: string): void {
        this.router.navigate(['projects', projectId]);
    }

    public openJoinProjectDialog() {
        this.joinProjectDialog = true;
    }
    public closeJoinProjectDialog() {
        this.joinProjectDialog = false;
    }
}
